var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('a', { staticClass: "reload-btn", on: { "click": _vm.handleReload } }, [_c('svg-icon', { staticClass: "svg-icon", attrs: { "icon-class": "restart" } })], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };